/* eslint-disable @typescript-eslint/no-explicit-any */

// Lectura: object-position listo para CSS. null/undefined = centro.
export function focalPosition(focal: string | null | undefined): string {
  return focal ?? "50% 50%"
}

// Escritura: el cliente manda x,y (0–100); clamp + formato controlado "NN% NN%".
// El string persistido SIEMPRE nace acá, así que es seguro como object-position.
export function buildFocal(x: number, y: number): string {
  const cx = Math.max(0, Math.min(100, Math.round(x)))
  const cy = Math.max(0, Math.min(100, Math.round(y)))
  return `${cx}% ${cy}%`
}

// Core I/O-injected (testeable, sin auth). Tenant-scoped por location_id.
export async function applySetMenuItemFocal(
  client: any,
  locationId: string,
  itemId: string,
  focal: string,
): Promise<{ ok: boolean; focal?: string; error?: string }> {
  const { error } = await client
    .from("items")
    .update({ image_focal: focal })
    .eq("id", itemId)
    .eq("location_id", locationId)
  if (error) return { ok: false, error: error.message }
  return { ok: true, focal }
}
